module.exports = __webpack_public_path__ + "static/media/icon_check_black.fb26e3c8.png";